import { Typography } from '@mui/material';
import ApiError from 'src/api/ApiError';

type ValidError = ApiError | Error | string;

// TODO support sx
interface Props {
  error?: ValidError | null;
  // errors?: ValidError[]; TODO implement
  fontSize?: string;
  mt?: number;
  mb?: number;
}
const ErrorMessage: React.FC<Props> = ({ error, fontSize, mt, mb }) => {
  if (!error) {
    return null;
  }

  const message = typeof error === 'string' ? error : error.message;
  const displayMessage = message?.trim() || 'An unexpected error occurred';

  return (
    <Typography
      color={'red'}
      fontSize={fontSize || '16px'}
      textAlign={'center'}
      mt={mt}
      mb={mb}
    >
      {displayMessage}
    </Typography>
  );
};

export default ErrorMessage;
